export const extractErrorMessage = (error) => {
  if (!error?.response) {
    return 'Network error. Please check your connection.';
  }

  const { data, status } = error.response;


  if (status === 400 && data?.errors) {
    const messages = [];
    Object.keys(data.errors).forEach(field => {
      const fieldErrors = data.errors[field];
      if (Array.isArray(fieldErrors)) {
        fieldErrors.forEach(msg => messages.push(msg));
      } else if (typeof fieldErrors === 'string') {
        messages.push(fieldErrors);
      }
    });
    return messages.length > 0 ? messages : 'Validation failed. Please check your input.';
  }

  if (Array.isArray(data)) {
    const messages = [];
    data.forEach(error => {
      if (error?.description) {
        messages.push(error.description);
      } else if (error?.Description) {
        messages.push(error.Description);
      } else if (typeof error === 'string') {
        messages.push(error);
      }
    });
    return messages.length > 0 ? messages : 'Operation failed. Please check your input.';
  }

  if (data?.code || data?.Code) {
    if (data?.description) {
      return data.description;
    }
    if (data?.Description) {
      return data.Description;
    }
  }

  if (data?.message) {
    return data.message;
  }

  if (data?.title) {
    return data.title;
  }

  if (typeof data === 'string' && data.length > 0) {
    return data;
  }

  if (data?.detail) {
    return data.detail;
  }

  if (data?.error) {
    if (typeof data.error === 'string') {
      return data.error;
    }
    if (data.error?.message) {
      return data.error.message;
    }
  }

  switch (status) {
    case 400:
      return 'Invalid request. Please check your input.';
    case 401:
      return 'Authentication required. Please login.';
    case 403:
      return 'You don\'t have permission to perform this action.';
    case 404:
      return 'The requested resource was not found.';
    case 409:
      return 'A conflict occurred. The resource may already exist.';
    case 422:
      return 'The data provided could not be processed.';
    case 500:
      return 'Server error. Please try again later.';
    case 502:
    case 503:
    case 504:
      return 'Service temporarily unavailable. Please try again later.';
    default:
      return `Error: Status ${status}`;
  }
};

export const displayErrorMessage = (error, enqueueSnackbar, options = {}) => {
  const messages = extractErrorMessage(error);

  if (Array.isArray(messages)) {
    messages.forEach(msg => {
      enqueueSnackbar(msg, {
        variant: 'error',
        autoHideDuration: 5000,
        ...options
      });
    });
  } else {
    enqueueSnackbar(messages, {
      variant: 'error',
      autoHideDuration: 5000,
      ...options
    });
  }
};

export const extractValidationErrors = (error) => {
  if (!error?.response?.data?.errors) {
    return {};
  }

  const formErrors = {};
  const errors = error.response.data.errors;

  Object.keys(errors).forEach(field => {
    const fieldErrors = errors[field];
    if (Array.isArray(fieldErrors) && fieldErrors.length > 0) {
      formErrors[field.charAt(0).toLowerCase() + field.slice(1)] = fieldErrors[0];
    } else if (typeof fieldErrors === 'string') {
      formErrors[field.charAt(0).toLowerCase() + field.slice(1)] = fieldErrors;
    }
  });

  return formErrors;
};